import * as React from "react";
import styled from "@emotion/styled";
import { GenericImage, Video } from "features/images";
import {
  Stack,
  Link,
  H2,
  FlexRow,
  IconExternalLink,
  RichText,
  Text,
} from "atoms";
import { formatURL } from "utils/text";
import type { GalleryItem } from "../types";
// import { GalleryBackButton } from "./GalleryBackButton";

type GalleryItemDetailsProps = { item: GalleryItem };
function GalleryItemDetails({ item }: GalleryItemDetailsProps) {
  const domain = item.link && new URL(item.link).host.replace("www.", "");
  const isExternal = domain !== new URL(window.location.href).host;

  return (
    <ItemContainer>
      <Stack gap="md">
        <Stack>
          {/* <GalleryBackButton
            artistId={item.ownerId}
            itemId={item.id}
            isEditing={isEditing}
          /> */}
          <H2 size="h3" textTransform="none">
            {item.title}
          </H2>
        </Stack>
        {item.image?.videoUrl ? (
          <SVideo
            src={item.image?.videoUrl ?? item.image?.url ?? ""}
            poster={item.image?.url1200 ?? item.image?.url}
          />
        ) : (
          <ItemImage
            loading="eager"
            src={item.image}
            width={item.image?.width}
            height={item.image?.height}
            sizes="(max-width: 831px) 100vw,
      (max-width: 991px) calc(100vw - 6.4rem),
      1080px"
          />
        )}
        <Stack gap="sm">
          {item.description && <RichText value={item.description} />}

          {item.link && (
            <Text size="xs">
              <Link href={item.link} target="_blank">
                <FlexRow as="span" gap="5px">
                  Learn more on {domain ?? formatURL(item.link)}
                  {isExternal && <IconExternalLink size=".85em" />}
                </FlexRow>
              </Link>
            </Text>
          )}
        </Stack>
      </Stack>
    </ItemContainer>
  );
}

const ItemContainer = styled.div({
  maxWidth: 1100,
  margin: "0 auto",
});
const ItemImage = styled(GenericImage)(({ theme }) => ({
  img: {
    borderRadius: theme.borderRadius.sm,
    height: "auto",
  },
}));
const SVideo = styled(Video)(({ theme }) => ({
  borderRadius: theme.borderRadius.sm,
}));

export { GalleryItemDetails };
